export default "__VITE_PUBLIC_ASSET__2838eb0b__"